import { createAction } from 'redux-act'

import { Article } from '../components/OrderDetailsPage/StyleYourLatestCarousel/types'

// ----------------------------------------
// ONLINE ORDERS
// ----------------------------------------
const fetchOnlineOrdersStart = createAction('ONLINE ORDERS/fetch start')
const fetchOnlineOrdersSuccess = createAction<any>('ONLINE ORDERS/fetch success')
const fetchOnlineOrdersFail = createAction<any>('ONLINE ORDERS/fetch fail')

// ----------------------------------------
// Style your latest A/B test
// ----------------------------------------
const setUserHasOrderRecommendations = createAction<boolean>(
  'STYLE YOUR LATEST/user has order recommendations',
)
const saveSYLArticles = createAction<Article[]>('STYLE YOUR LATEST/save articles')

// ----------------------------------------
// STORE ORDERS
// ----------------------------------------
const fetchStoreOrdersStart = createAction('STORE ORDERS/fetch start')
const fetchStoreOrdersSuccess = createAction<any>('STORE ORDERS/fetch success')
const fetchStoreOrdersTimeout = createAction('STORE ORDERS/fetch timeout')
const fetchStoreOrdersFail = createAction<any>('STORE ORDERS/fetch fail')

const fetchStoreOrdersAddressesStart = createAction('STORE ORDERS ADDRESSES/fetch start')
const fetchStoreOrdersAddressesSuccess = createAction<any>('STORE ORDERS ADDRESSES/fetch success')
const fetchStoreOrdersAddressesFail = createAction<any>('STORE ORDERS ADDRESSES/fetch fail')

// ----------------------------------------
// ONLINE ACTIVE ORDERS
// ----------------------------------------
const fetchOnlineActiveOrdersStart = createAction('ONLINE ACTIVE ORDERS/fetch start')
const fetchOnlineActiveOrdersSuccess = createAction<any>('ONLINE ACTIVE ORDERS/fetch success')
const fetchOnlineActiveOrdersFail = createAction<any>('ONLINE ACTIVE ORDERS/fetch fail')

// ----------------------------------------
// ONLINE ORDER DETAILS
// ----------------------------------------
const fetchOnlineOrderDetailsStart = createAction('ONLINE ORDER/fetch start')
const fetchOnlineOrderDetailsSuccess = createAction<any>('ONLINE ORDER/fetch success')
const fetchOnlineOrderDetailsFail = createAction<any>('ONLINE ORDER/fetch fail')

const cancelOnlineOrderStart = createAction('ONLINE ORDER/cancel order start')
const cancelOnlineOrderSuccess = createAction<any>('ONLINE ORDER/cancel order success')
const cancelOnlineOrderFail = createAction<any>('ONLINE ORDER/cancel order fail')
const resetCancelOnlineOrder = createAction('ONLINE ORDER/reset')
const updateCancelledOnlineOrder = createAction<any>('ONLINE ORDER/update cancelled order')

// ----------------------------------------
// STORE ORDER DETAILS
// ----------------------------------------
const fetchStoreOrderDetailsStart = createAction<any>('STORE ORDER/fetch start')
const fetchStoreOrderDetailsSuccess = createAction<any>('STORE ORDER/fetch success')
const fetchStoreOrderDetailsFail = createAction<any>('STORE ORDER/fetch fail')

// ----------------------------------------
// OTHER
// ----------------------------------------
const setHubOrderList = createAction<any>('PURCHASES/set hub order list')

const setNoMoreOnlineResults = createAction('PURCHASES/set no more online results')
const setNoMoreStoreResults = createAction('PURCHASES/set no more store results')

const setIsOnlineLoadMoreUsed = createAction<boolean>('PURCHASES/set is online load more used')
const setIsStoreLoadMoreUsed = createAction('PURCHASES/set is store load more used')

const setSelectedTab = createAction<any>('PURCHASES/set selected tab')

const setBackToOrderUrl = createAction<string>('PURCHASES/set Back To Order URL for COD order')

const setCodReturnUrl = createAction<string>('PURCHASES/set return URL for COD order')

const setTotalOrdersCount = createAction<{ type: 'online' | 'store'; count: number }>(
  'PURCHASES/set total orders count',
)
const setCallRateAndReviewAPIStatus = createAction<boolean>('PURCHASES/set review api status')
const addToBagStart = createAction('ADD TO BAG/add to bag start')
const addToBagSuccess = createAction('ADD TO BAG/add to bag success', (response) => ({ response }))
const addToBagFail = createAction('ADD TO BAG/add to bag fail')

const showAddToBagVerificationStart = createAction('ADD TO BAG/add to bag verification start')
const showAddToBagVerificationSuccess = createAction(
  'ADD TO BAG/add to bag verification success',
  (productData) => ({
    productData,
  }),
)
const showAddToBagVerificationError = createAction('ADD TO BAG/add to bag verification error')

const setShouldShowAddToBagVerification = createAction(
  'ADD TO BAG/add to bag verification show',
  (response) => ({
    response,
  }),
)

export default {
  setHubOrderList,
  setNoMoreOnlineResults,
  setNoMoreStoreResults,
  setIsOnlineLoadMoreUsed,
  setIsStoreLoadMoreUsed,
  setSelectedTab,

  fetchOnlineOrdersStart,
  fetchOnlineOrdersSuccess,
  fetchStoreOrdersTimeout,
  fetchOnlineOrdersFail,

  fetchStoreOrdersStart,
  fetchStoreOrdersSuccess,
  fetchStoreOrdersFail,

  fetchOnlineActiveOrdersStart,
  fetchOnlineActiveOrdersSuccess,
  fetchOnlineActiveOrdersFail,

  fetchOnlineOrderDetailsStart,
  fetchOnlineOrderDetailsSuccess,
  fetchOnlineOrderDetailsFail,

  fetchStoreOrderDetailsStart,
  fetchStoreOrderDetailsSuccess,
  fetchStoreOrderDetailsFail,

  fetchStoreOrdersAddressesStart,
  fetchStoreOrdersAddressesSuccess,
  fetchStoreOrdersAddressesFail,

  cancelOnlineOrderStart,
  cancelOnlineOrderSuccess,
  cancelOnlineOrderFail,
  resetCancelOnlineOrder,
  updateCancelledOnlineOrder,
  addToBagStart,
  addToBagSuccess,
  showAddToBagVerificationStart,
  showAddToBagVerificationSuccess,
  addToBagFail,
  showAddToBagVerificationError,
  setShouldShowAddToBagVerification,
  setTotalOrdersCount,
  setBackToOrderUrl,
  setCodReturnUrl,

  setCallRateAndReviewAPIStatus,
  // Style your latest A/B test
  saveSYLArticles,
  setUserHasOrderRecommendations,
}
